// extracted by mini-css-extract-plugin
export default {"root":"style_root__Dx9B6","ribbon":"style_ribbon__uK4F5","round":"style_round__m2b+n"};